export default __webpack_public_path__ + "static/media/todomoda.05a85144.svg";